import React, { useState, useEffect, useCallback } from "react";
import { X } from "react-feather";
import NumericPad from "../../common/NumericPad.jsx";
import { ManagerService } from "../../../../services/Management/managerService.ts";

export default function ManagerApprovalModal({ isOpen, onClose, onApproved }) {
  const [pin, setPin] = useState("");
  const [errorText, setErrorText] = useState("");
  const [showError, setShowError] = useState(false);
  const [loading, setLoading] = useState(false);

  // Reset on open
  useEffect(() => {
    if (isOpen) {
      setPin("");
      setErrorText("");
      setShowError(false);
      setLoading(false);
    }
  }, [isOpen]);

  const handleApprove = useCallback(async () => {
    if (pin.length !== 6 || loading) return;

    setLoading(true);
    try {
      const manager = await ManagerService.CheckPinCode(pin);

      if (!manager) {
        setErrorText("Invalid PIN. Please try again.");
        setShowError(true);
        setLoading(false);
        setTimeout(() => setPin(""), 150);
        return;
      }

      setLoading(false);
      setPin("");
      onApproved(manager);
      onClose();

    } catch (ex) {
      setErrorText("Unexpected error.");
      setShowError(true);
      setLoading(false);
      setTimeout(() => setPin(""), 150);
    }
  }, [pin, loading, onApproved, onClose]);

  // Auto-submit on 6 digits
  useEffect(() => {
    if (pin.length > 0 && showError) setShowError(false);
    if (pin.length === 6 && !loading) handleApprove();
  }, [pin, showError, loading, handleApprove]);

  if (!isOpen) return null;

  return (
    <div
      className="modal fade show d-block pos-modal"
      style={{
        background: "rgba(0,0,0,0.55)",
        zIndex: 40000
      }}
    >
      <div className="modal-dialog modal-sm modal-dialog-centered">
        <div className="modal-content rounded-4 shadow-lg">

          {/* HEADER */}
          <div className="modal-header border-0 pb-2">
            <h5 className="modal-title fw-semibold">Manager Approval</h5>
            <button className="btn btn-light" onClick={onClose}>
              <X size={18} />
            </button>
          </div>

          {/* BODY */}
          <div className="modal-body text-center position-relative">

            {/* Loading overlay (matches staff modal) */}
            {loading && (
              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  background: "rgba(255,255,255,0.6)",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  zIndex: 40001,
                  borderRadius: "12px"
                }}
              >
                <div className="spinner-border text-primary"></div>
              </div>
            )}

            <input
              type="password"
              className="form-control mb-2"
              placeholder="Enter Manager PIN"
              value={"•".repeat(pin.length)}
              maxLength={6}
              autoFocus
              onChange={(e) => {
                const digits = e.target.value.replace(/\D/g, "").slice(0, 6);
                setPin(digits);
                setShowError(false);
              }}
              style={{
                textAlign: "center",
                fontSize: "1.7rem",
                padding: "12px",
                borderRadius: "10px",
                background: "#fff8cc",
                letterSpacing: "6px",
              }}
            />

            {showError && (
              <div className="text-danger small">{errorText}</div>
            )}

            <NumericPad value={pin} onChange={(val) => setPin(val.slice(0, 6))} />
          </div>

        </div>
      </div>
    </div>
  );
}
